import styled, { css, keyframes } from 'styled-components';
import { grey40, grey20 } from 'Styles/colors';
import LazyLoadOriginal from '../LazyLoad/LazyLoad';

export const pulseAnimation = keyframes`
  0%, 100% {
    background-color: ${grey20};
  }
  45% {
    background-color: ${grey40};
  }
`;

export const LazyLoad = styled(LazyLoadOriginal)`
  position: absolute;
  inset: 0;
`;

export const Image = styled.img`
  position: absolute;
  width: 100%;
  opacity: ${({ hasLoaded }) => (hasLoaded ? 1 : 0)};
`;

export const Container = styled.div`
  height: 0;
  padding-bottom: ${({ aspectRatio = 1 }) => aspectRatio * 100}%;
  overflow: hidden;
  position: relative;
  ${({ hasLoaded }) =>
    hasLoaded
      ? 'animation: none'
      : css`
          animation: ${pulseAnimation} 3s ease-out infinite normal;
        `};

  & > ${Image} {
    transition: opacity 100ms ease-in;
    top: 0;
  }
`;
